export const company =
{
    name: 'Bangkok Living Development',
    welcomeName: 'Bangkok Living Development',
    mainServiceArea: 'Bangkok',
    navPhone: '+66 82 956 3334',
    phone1: '+66 82 956 3334',
    phone2: '',
    email: 'contact@email.com',
    address1: 'Prasanmith Plaza , 3 Floor, Room No. 305 Soi',
    address2: 'Sukhumvit 23, Sukhumvit Road Khlong Toey Neau',
    address3: 'Watthana, Bangkok 10110',
    phoneUrl: 'tel:+66829563334',
    lineUrl: 'https://lin.ee/HgAKBHb',
    lineId: '@693drjgf',
    whatsappUrl: 'https://wa.me/0066829563334',
    // whatsappUrl: '',
    youtubeUrl: '',
    facebookUrl: '',
    instagramUrl: '',
    tiktokUrl: '',
    linkedInUrl: ''
}
